import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { getErrorString } from "../display/ErrorStrings";
import AggregatedCdisbSummaryPage from "../containers/AggregatedCdisbSummaryPage";
import AggregatedCdisbDetailPage from "../containers/AggregatedCdisbDetailPage";
import GenericReportPage from "../containers/GenericReportPage";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class HomePageCompanyReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      loaded: false,
      reportChange: false,
      reports: [],
      reasons: [],
      selectedOption: {},
    };
    this.onReportChange = this.onReportChange.bind(this);
  }

  onReportChange(e) {
    let reports = this.state.reports;
    let i;
    for (i = 0; i < reports.length; i++) {
      if (reports[i].type === e.target.value) {
        this.setState({ selectedOption: reports[i] });
        this.setState({ reportChange: true });
        break;
      }
    }
  }

  componentDidUpdate() {
    if (this.state.reportChange) {
      this.setState({ reportChange: false });
    }
  }

  componentDidMount() {
    var companyReportTypesList = {};
    companyReportTypesList.secureToken = this.props.secureToken;
    companyReportTypesList.data = this.props.prefs.companyReportTypes;
    fetch("on_company_reports_entry", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(companyReportTypesList),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else if (reply.reports.length === 0) {
          this.setState({ notifyString: "No data" });
        } else {
          this.setState({ reports: reply.reports });
          this.setState({ reasons: reply.returnCodes });
          this.setState({ selectedOption: reply.reports[0] });
          this.setState({ loaded: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  render() {
    return (
      <div style={{ margin: 20 }}>
        {this.state.errorString.length !== 0 && (
          <Typography variant="h6" color="error">
            {this.state.errorString}
          </Typography>
        )}
        {this.state.notifyString.length !== 0 && (
          <Typography variant="h6" color="primary">
            {this.state.notifyString}
          </Typography>
        )}
        {this.state.loaded && !this.state.reportChange && (
          <div>
            {!this.state.selectedOption.generic &&
              this.state.selectedOption.type === "cdisb_summary" && (
                <AggregatedCdisbSummaryPage
                  onReportChange={this.onReportChange}
                  reports={this.state.reports}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  prefs={this.props.prefs}
                  secureToken={this.props.secureToken}
                />
              )}
            {!this.state.selectedOption.generic &&
              this.state.selectedOption.type === "cdisb_detail" && (
                <AggregatedCdisbDetailPage
                  onReportChange={this.onReportChange}
                  reports={this.state.reports}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  prefs={this.props.prefs}
                  secureToken={this.props.secureToken}
                />
              )}
            {this.state.selectedOption.generic && (
              <GenericReportPage
                onReportChange={this.onReportChange}
                reports={this.state.reports}
                option={this.state.selectedOption}
                reasons={this.state.reasons}
                history={this.props.history}
                prefs={this.props.prefs}
                secureToken={this.props.secureToken}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(HomePageCompanyReports);
